// extracted by mini-css-extract-plugin
var _1 = "TableSkeleton-moduleTableSkeleton__o0aA3 TableSkeleton-moduleTableSkeletonInline__Ms4h1";
var _2 = "TableSkeleton-moduleTableSkeletonInline__Ms4h1";
var _3 = "TableSkeleton-moduleTableSkeletonRow__B_Tyw";
var _4 = "TableSkeleton-moduleskeleton__ttI_0 Skeleton-moduleSkeleton__Mlrfv";
var _5 = "TableSkeleton-moduleskeletonCheckbox__S_i2N";
var _6 = "TableSkeleton-moduleskeletonHeader__WztSq";
var _7 = "TableSkeleton-moduleskeletonScrollButton__J7c13 TableSkeleton-moduleskeleton__ttI_0 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "TableSkeleton", _2 as "TableSkeletonInline", _3 as "TableSkeletonRow", _4 as "skeleton", _5 as "skeletonCheckbox", _6 as "skeletonHeader", _7 as "skeletonScrollButton" }
